import { getAverageCaseWeight, getCaseWeightSummaryRows, getCaseWeightUom } from './caseWeightSummaryUtils';

const cellStyle = {
    borderBottom: '1px solid #e0e0e0',
    padding: '10px 4px',
};

const headerStyle = {
    ...cellStyle,
    color: '#9e9e9e',
    fontSize: '0.85rem',
    fontWeight: 400,
};

/**
 * Read-only Units per Case summary when cases are recorded by case weight (QC app parity).
 *
 * @param {object} props
 * @param {string|null|undefined} props.baseUnitUom
 * @param {Record<string, object>|object[]} props.caseCounts
 * @param {number|string|null|undefined} props.receivedUnitCount
 * @param {number|string|null|undefined} props.unitCountVariance
 */
function CaseWeightSummary({ baseUnitUom, caseCounts, receivedUnitCount, unitCountVariance }) {
    const rows = getCaseWeightSummaryRows(caseCounts);
    const caseWeightUom = getCaseWeightUom(caseCounts);
    const averageCaseWeight = getAverageCaseWeight(rows);
    const weightHeader = caseWeightUom ? `Case Weight (${caseWeightUom})` : 'Case Weight';
    const averageWeightLabel = caseWeightUom ? `Average Case Weight (${caseWeightUom})` : 'Average Case Weight';
    const averageUnitsLabel = baseUnitUom ? `Average Units (${baseUnitUom})` : 'Average Units';
    const discrepancy = unitCountVariance ?? 0;

    return (
        <div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>Case Number</th>
                        <th style={{ ...headerStyle, textAlign: 'right' }}>{weightHeader}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.caseIdx}>
                            <td style={{ ...cellStyle, textAlign: 'left' }}>{row.caseIdx}</td>
                            <td style={{ ...cellStyle, textAlign: 'right' }}>{row.caseWeight ?? ''}</td>
                        </tr>
                    ))}
                    <tr>
                        <td style={{ ...cellStyle, textAlign: 'left' }}>{averageWeightLabel}</td>
                        <td style={{ ...cellStyle, textAlign: 'right' }}>{averageCaseWeight ?? ''}</td>
                    </tr>
                    <tr>
                        <td style={{ ...cellStyle, textAlign: 'left' }}>{averageUnitsLabel}</td>
                        <td style={{ ...cellStyle, textAlign: 'right' }}>{receivedUnitCount ?? ''}</td>
                    </tr>
                </tbody>
            </table>
            <div style={{ textAlign: 'center', marginTop: '16px' }}>
                <h3>% DISCREPANCY: {discrepancy}</h3>
            </div>
        </div>
    );
}

export { CaseWeightSummary };
